<script>
	import { user, view } from "../client.svelte.js";
	import Sheet from "./Sheet.svelte";
	import Sidebar from "../elements/Sidebar.svelte";

	let grpTales = $derived(
		Object.groupBy(
			user.tales.values()
				.filter(tale => tale.heroes.includes(view.character.ID) )
				.toArray()
				.sort((a,b) => a.NUM - b.NUM)
			, ({FSHP}) => FSHP))

	let expandedID = $state(null)

	function toggle_synopsis(tale) {
		expandedID = (expandedID === tale.ID) ? null : tale.ID
	}

	function hero_names(tale) {
		return tale.heroes.map(heroID => user.characters.get(heroID)?.name ?? heroID).join(", ")
	}

	function total_XP(tales) {
		return tales.reduce((sum, tale) => sum + (tale.XP ?? 0), 0)
	}
</script>


<!-------------------------------- HTML -------------------------------------->

<section id='career'>

	<Sidebar/>

	<Sheet>
		{#each Object.keys(grpTales) as fellowship}
			<section class="sheet-section">
				<h2 class="sheet-title">{user.fellowships.get(fellowship)?.name ?? fellowship}</h2>
				<div class="tale-row kicker colhead">
					<span>Nr</span>
					<span>Name</span>
					<span>Kampagne</span>
					<span>Meister</span>
					<span>Helden</span>
					<span>Start</span>
					<span class="right">EP</span>
				</div>
				{#each grpTales[fellowship] as tale}
					{@const expanded = expandedID === tale.ID}
					<div class="tale">
						<button class="tale-row" data-help="tale" aria-expanded={expanded} onclick={() => toggle_synopsis(tale)}>
							<span class="tale-num num">{tale.NUM ?? tale.ID}</span>
							<span class="tale-name"><span class="fa {expanded ? 'icon-chevron-down' : 'icon-chevron-right'}"></span>{tale.name}</span>
							<span class="campaign" data-help="campaigne">{tale.campaigne ?? ""}</span>
							<span>{tale.master ?? ""}</span>
							<span class="heroes">{hero_names(tale)}</span>
							<span class="num">{tale.start ?? ""}</span>
							<span class="right tale-xp num">{tale.XP ?? ""}</span>
						</button>
						{#if expanded}
							<p class="synopsis" lang="de">{tale.synopsis || "Keine Zusammenfassung vorhanden."}</p>
						{/if}
					</div>
				{/each}
				<div class="total">
					<span class="kicker right">Summe</span>
					<span class="right tale-xp num">{total_XP(grpTales[fellowship])}</span>
				</div>
			</section>
		{:else}
			<p class="muted">Dieser Held hat noch keine Abenteuer erlebt.</p>
		{/each}
	</Sheet>
</section>


<!-------------------------------- STYLE -------------------------------------->

<style lang="sass">
	.tale-row
		width: 100%
		display: grid
		grid-template-columns: 48px minmax(0, 2fr) minmax(0, 1.2fr) 100px minmax(0, 1.3fr) 110px 48px
		column-gap: 18px
		align-items: baseline
		padding: 9px 0
		border: none
		background: none
		text-align: left
		font-size: 14px
		cursor: pointer

		&.colhead
			padding: 8px 0
			border-bottom: 1px solid var(--color-accent-300)
			letter-spacing: .12em
			font-size: 12px
			cursor: default

		&:not(.colhead):hover
			background: var(--hover-tint)

	.tale
		border-bottom: 1px solid var(--color-divider)

	.tale-num
		font-family: var(--font-heading)
		font-size: 20px
		color: var(--color-accent-700)

	.tale-name
		display: flex
		align-items: baseline
		gap: 8px
		font-size: 16px

		.fa
			font-size: 10px
			color: var(--color-accent-600)

	.campaign
		font-style: italic
		color: var(--color-neutral-800)

	.heroes
		font-size: 13px
		color: var(--color-neutral-700)

	.tale-xp
		font-family: var(--font-heading)
		font-size: 18px

	.synopsis
		max-width: 720px
		margin: 2px 0 16px 66px
		text-align: justify
		hyphens: auto
		font-size: 15px
		font-style: italic
		line-height: 1.7
		color: var(--color-neutral-800)
		white-space: pre-wrap

	.total
		display: grid
		grid-template-columns: minmax(0, 1fr) 48px
		column-gap: 18px
		align-items: baseline
		padding: 10px 0
		border-top: 1px solid var(--color-accent)

		.tale-xp
			font-size: 20px
</style>
